/* eslint-disable react/react-in-jsx-scope */
export default function BrazilMoney(props) {
  const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.value);
  return (
    money
  );
}
